import apiClient from '@shared/api/apiClient';

/**
 * 알림 설정 정보 조회 API
 * GET /api/v1/notifications/alarms
 * @returns {Promise<Object>} 서버 응답 데이터 (resultData: { app: boolean, email: boolean })
 */
async function getAlarms() {
  const response = await apiClient.get('/v1/notifications/alarms', {
    withAuth: true,
  });
  return response.data;
}

/**
 * 알림 설정 변경 API
 * PUT /api/v1/notifications/alarms
 * @param {boolean} app - 앱 Push 알림 설정 여부
 * @param {boolean} email - 이메일 알림 설정 여부
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function updateAlarms(app, email) {
  const response = await apiClient.put(
    '/v1/notifications/alarms',
    {
      app,
      email,
    },
    {
      withAuth: true,
    },
  );
  return response.data;
}

export { getAlarms, updateAlarms };
